import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import TextInputField from "../../../components/editable/EditableField/fields/TextInputField";
import ErrorDialog from "../../../components/notifications/errorDialog/ErrorDialog";
import { api, CategoryType } from "../../../logic/api";

import { SessionContext } from "../../../utility/useSession";
import { isSysAdmin } from "../../../utility/utils";
import propTypes from "prop-types";
import CategorySelector from "./CategorySelector";
import usePaths from "../../../utility/paths";
import { useReleaseManagement, ReleaseFlag } from "../../../utility/feature-management";
import DataSourceSelector from "./DataSourceSelector";
import { useTranslation } from "react-i18next";

const ReportCreateNew: React.FunctionComponent<{
    category?: string;
}> = (props) => {
    const paths = usePaths();
    const history = useHistory();
    const session = useContext(SessionContext);
    const { t } = useTranslation();

    const createReportApi = api.hooks.reports.create();

    const [showCreateReportDialog, setShowCreateReportDialog] = useState(false);
    const [reportName, setReportName] = useState("");
    const [category, setCategory] = useState("");
    const [dataSource, setDataSource] = useState("");

    useEffect(() => {
        setCategory(props.category || "");
    }, [props.category]);

    const createNewReport = () => {
        setReportName("");
        setShowCreateReportDialog(true);
    }

    const confirmCreateNewReport = async () => {
        if (reportName.length == 0) {
            return;
        }
        if (category.length == 0) {
            return;
        }
        createReportApi.send(session.current.context, {
            name: reportName,
            category: category,
          dataSource: dataSource
        }, (report) => {
            if (report != null) {
                history.push(paths.reportEdit(report.id.toString()));
            }
        });

    }

    return <Fragment>

        <Dialog
            open={showCreateReportDialog}

            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle id="alert-dialog-slide-title">{t("reports.newReport")}</DialogTitle>
            <DialogContent>
                <div style={{ paddingTop: 10 }}>
                    <TextInputField label={t("reports.reportName")} value={reportName} onChange={(value) => {
                        setReportName(value);
                    }} />
                </div>
                <div style={{ paddingTop: 20 }}>

                    <CategorySelector label={t("reports.selectCategory")} type={CategoryType.reports} value={category} onChange={(value) => {
                        setCategory(value);
                    }}></CategorySelector>
                </div>
          <div style={{ paddingTop: 20 }}>

                    <DataSourceSelector label={t("reports.selectData")} value={dataSource} onChange={(value) => {
                        setDataSource(value);
                    }}></DataSourceSelector>
          </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShowCreateReportDialog(false)} color="secondary">{t("general.cancel")}</Button>
          <Button disabled={reportName.length == 0 || category.length == 0 || dataSource.length == 0} onClick={() => confirmCreateNewReport()} color="primary">{t("reports.createReport")}</Button>
            </DialogActions>
        </Dialog>
        <ErrorDialog err={createReportApi.err}></ErrorDialog>
        {isSysAdmin(session) && (
            <Button variant="contained" color="secondary" onClick={() => createNewReport()}><FiPlus style={{ marginRight: 10 }}></FiPlus>{t("reports.newReport")}</Button>
        )}
    </Fragment>;
}

ReportCreateNew.propTypes = {
    category: propTypes.string
}

export default ReportCreateNew;
